import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { useSectionsData } from "../../utils/useSectionsData.ts";

interface Link {
  link_type: string;
  tr_page_link_label: string;
  tr_custom_link_label: string;
  page_link: string;
  custom_url: string;
}

export const Footer = () => {
  const year = new Date().getFullYear();
  const sections = useSectionsData();
  const footerSection = sections.pp_v7_footer_section;
  const footerText = footerSection?.tr_footer_text;
  const copyright = footerSection?.tr_copyright_text;
  const copyrightText = copyright.replace("###year###", year);
  const links = footerSection?.footer_links;

  return (
    <PageWrapper backgroundColor="section_dark">
      <div className={s.footer}>
        {footerText && <div className={s.footer__text}>{footerText}</div>}
        <div>{copyrightText}</div>
        {links && links.length > 0 && (
          <div className={s.footer__links}>
            {links.map((item: Link, index: number) =>
              item.link_type === "page_link" ? (
                <a href={item.page_link} key={index}>
                  {item.tr_page_link_label}
                </a>
              ) : (
                <a href={item.custom_url} key={index}>
                  {item.tr_custom_link_label}
                </a>
              )
            )}
          </div>
        )}
      </div>
    </PageWrapper>
  );
};
